import React from 'react'

import { CsvTable } from '../../../../shared'
import type { SortType } from '../../../../shared/components/CsvTable/CsvTable'
import { renderArticleElements } from '../../../../shared/renderers/article-element-renderer'
import styles from './MortgageRates.module.scss'

type MortgageRatesProps = {
  mortgageRatesData: {
    headings: string[]
    columnDataTypes: SortType[]
    tableBody: any[]
  }
}

export const MortgageRates: React.FC<MortgageRatesProps> = ({
  mortgageRatesData: { headings, columnDataTypes, tableBody },
}) => {
  return (
    <div className={styles.mortgageRates} data-testid="mortgage-rates">
      <CsvTable
        headings={headings}
        columnDataTypes={columnDataTypes}
        tableBody={tableBody}
        renderArticleElements={renderArticleElements}
      />
    </div>
  )
}
